
import {
    Modal,
    ModalBody,
    ModalButtons,
    ModalContent,
    ModalHeader,
    ModalHeaderTitle,
} from "@ui/common/Modal"
import React from "react"
import { Button, ButtonType } from "./buttons/Button"

export function FetchDataErrorModal({
    title = "Error",
    message = "There was an error retrieving data.. Please try again.",
    buttonLabel = "View",
    isVisible,
    onClick,
    onRetry
}: {
    title: string,
    message: string,
    buttonLabel?: string,
    isVisible: boolean
    onClick: () => void
    onRetry: () => void
    
}): JSX.Element {
    return (
        <Modal useContentTag={true} isVisible={isVisible} isClosable={false}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>{title}</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalButtons>
                    <Button
                        label={buttonLabel}
                        type={ButtonType.Text}
                        onClick={() => onClick()}
                    />
                    <Button label={"Retry"} onClick={() => onRetry()} />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}